import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Verticals from "@/components/landing/Verticals";
import Services from "@/components/landing/Services";
import ServicesFlow from "@/components/landing/ServicesFlow";
import Reels from "@/components/landing/Reels";
import CaseStudies from "@/components/landing/CaseStudies";
import Process from "@/components/landing/Process";
import About from "@/components/landing/About";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import AIAssistant from "@/components/landing/AIAssistant";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import WelcomePopup from "@/components/landing/WelcomePopup";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative min-h-screen bg-[#0a0b08] text-white overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Verticals />
        <Services />
        <ServicesFlow />
        <Reels />
        <CaseStudies />
        <Process />
        <About />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <AIAssistant />
      <WhatsAppFloat />
      <WelcomePopup />
    </div>
  );
}
